import React from 'react';

const SaveSvg = ({ ...props }) => {
  return (
    <svg
      {...props}
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9444 15H2.05556C1.643 15 1.24733 14.8361 0.955612 14.5444C0.663888 14.2527 0.5 13.857 0.5 13.4444V2.55556C0.5 2.143 0.663888 1.74733 0.955612 1.45561C1.24733 1.16389 1.643 1 2.05556 1H10.6111L14.5 4.88889V13.4444C14.5 13.857 14.3361 14.2527 14.0444 14.5444C13.7527 14.8361 13.357 15 12.9444 15Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3891 15.0001V8.77783H3.61133V15.0001"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.61133 1V4.88889H9.83355"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SaveSvg;
